export default __webpack_public_path__ + "static/media/disable-sound.477d0574.mp3";